import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from "react";
import RiotBarLoader from "@riotgames/riotbar-react";
import { useTranslation } from "gatsby-plugin-react-i18next";

interface RiotBarProps {
  locale: string;
}

export const RiotBar: FunctionComponent<RiotBarProps> = ({ locale }) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const { t } = useTranslation();
  /**
   * Example riotbar onLoad function.
   * @see https://docs.google.com/document/d/1CobNV5Oeu8iCPoeubcIGulllJAE0JQ_UmmydfH_rdBg/edit?usp=sharing
   */
  const onRiotBarLoaded = useCallback(() => {
    setHasLoaded(true);
    // console.log(window.RiotBar.data.footer);

    const footerContent = document.querySelector(".riotbar-footer-content");

    if (footerContent) {
      const p = document.createElement("p");
      p.innerText = t(`${locale === "en-us" ? "" : "home_"}footer.copyright`);
      p.classList.add("copyright");
      footerContent.appendChild(p);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!hasLoaded) return;
  }, [hasLoaded]);

  return (
    <header>
      {/**
       * Add Riotbar to all pages via the layout component.
       * @see https://docs.google.com/document/d/1CobNV5Oeu8iCPoeubcIGulllJAE0JQ_UmmydfH_rdBg/edit#
       * @see https://egh.riotgames.com/wwpub/riotbar-react-example
       * @see https://gh.riotgames.com/jrose/riotbar-react-example
       */}
      <RiotBarLoader
        locale={locale}
        product="glasc-industries"
        environment={process.env.GATSBY_RIOTBAR_ENV ?? "production"}
        onLoad={onRiotBarLoaded}
      />
    </header>
  );
};
